/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type GetOrganizationQueryVariables = Types.Exact<{
  orgId: Types.Scalars['uuid']['input'];
}>;

export type GetOrganizationQuery = {
  __typename?: 'query_root';
  organizations_by_pk?: {
    __typename?: 'organizations';
    id: string;
    name: string;
    disabled: boolean;
    description?: string | null;
    parent_organization_id?: string | null;
    workos_organization_id?: string | null;
    inactivity_timeout_minutes?: number | null;
    is_api_module_enabled: boolean;
    is_audit_trail_enabled: boolean;
    is_control_ai_review_enabled: boolean;
    is_vendor_questionnaire_ai_review_enabled: boolean;
    is_day_zero_ai_features_enabled: boolean;
    is_risk_approval_workflows_enabled: boolean;
    is_vendor_approval_workflows_enabled: boolean;
    is_risks_module_enabled: boolean;
    is_vendors_module_enabled: boolean;
    is_controls_module_enabled: boolean;
    is_policies_module_enabled: boolean;
    is_program_creation_enabled: boolean;
    is_policy_acknowledgements_enabled: boolean;
    is_client_questionnaires_enabled: boolean;
    is_trust_portal_enabled: boolean;
    is_grove_enabled: boolean;
    is_agent_trace_enabled: boolean;
    default_user_role_id?: string | null;
    tenants: Array<{ __typename?: 'organization_tenants'; name: string }>;
  } | null;
};

export const GetOrganizationDocument = `
    query GetOrganization($orgId: uuid!) {
  organizations_by_pk(id: $orgId) {
    id
    name
    disabled
    description
    parent_organization_id
    workos_organization_id
    inactivity_timeout_minutes
    is_api_module_enabled
    is_audit_trail_enabled
    is_control_ai_review_enabled
    is_vendor_questionnaire_ai_review_enabled
    is_day_zero_ai_features_enabled
    is_risk_approval_workflows_enabled
    is_vendor_approval_workflows_enabled
    is_risks_module_enabled
    is_vendors_module_enabled
    is_controls_module_enabled
    is_policies_module_enabled
    is_program_creation_enabled
    is_policy_acknowledgements_enabled
    is_client_questionnaires_enabled
    is_trust_portal_enabled
    is_grove_enabled
    is_agent_trace_enabled
    default_user_role_id
    tenants: organization_tenants {
      name
    }
  }
}
    ` as string & TypedDocumentNode<GetOrganizationQuery, GetOrganizationQueryVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    GetOrganization: build.query<GetOrganizationQuery, GetOrganizationQueryVariables>({
      query: (variables) => ({ document: GetOrganizationDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useGetOrganizationQuery, useLazyGetOrganizationQuery } = injectedRtkApi;
